module.exports = __webpack_public_path__ + "media/images/home/curso-dae8af89dbc99a5f53ba835c7beb6cc3.png";